/*------------------------------------*\
  #Location Feature
\*------------------------------------*/

class LocationFeature {
  constructor(section) {
    this.section = section;
    this.mediaContainer = section.querySelector('.location-feature__media');
    this.drawers = section.querySelectorAll('drawer-disclosure');
    this.images = section.querySelectorAll('[data-location-image]');
    
    this.init();
  }

  init() {
    if (!this.mediaContainer || this.drawers.length === 0 || this.images.length === 0) {
      return;
    }

    // Listen for drawer open/close events
    this.drawers.forEach((drawer) => {
      const details = drawer.querySelector('details');
      if (details) {
        details.addEventListener('toggle', this.handleDrawerToggle.bind(this));
      }
    });

    // Set initial state - show first image if first drawer is open by default
    this.updateImageVisibility();
  }

  handleDrawerToggle(event) {
    const details = event.target;
    const isOpen = details.hasAttribute('open');
    
    if (isOpen) {
      const locationId = details.getAttribute('data-id');
      this.showImageForLocation(locationId);
    }
  }

  showImageForLocation(locationId) {
    // Hide all images
    this.images.forEach((image) => {
      image.classList.remove('is-visible');
    });

    // Show the corresponding image
    const targetImage = this.mediaContainer.querySelector(
      `[data-location-image="${locationId}"]`
    );
    
    if (targetImage) {
      targetImage.classList.add('is-visible');
    }
  }

  updateImageVisibility() {
    // Find the first open drawer
    const openDrawer = Array.from(this.drawers).find((drawer) => {
      const details = drawer.querySelector('details');
      return details && details.hasAttribute('open');
    });

    if (openDrawer) {
      const details = openDrawer.querySelector('details');
      const locationId = details.getAttribute('data-id');
      this.showImageForLocation(locationId);
    } else if (this.images.length > 0) {
      // If no drawer is open, show the first image by default
      this.images[0].classList.add('is-visible');
    }
  }
}

// Initialize on DOMContentLoaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLocationFeatures);
} else {
  initLocationFeatures();
}

function initLocationFeatures() {
  document.querySelectorAll('.location-feature').forEach((section) => {
    new LocationFeature(section);
  });
}

